import classNames from "classnames";
import ColumnLegend from "./ColumnLegend";

const RESULT_TABS = [
  { code: "estimated_tax_open_positions", label: "Estimated Tax OpenPositions" },
  { code: "open_positions", label: "OpenPositions" },
  { code: "estimated_tax_closed_positions", label: "Estimated Tax ClosedPositions" },
  { code: "closed_positions", label: "ClosedPositions" },
];

const SUBTITLES = {
  open_positions: "Open Tax Lots (Since Inception) · por lote",
  closed_positions: "Closed Tax Lots · por lote cerrado en el periodo",
};

export default function ResultTabs({ active, onChange }) {

  const isEstimated = active === "estimated_tax_open_positions" || active === "estimated_tax_closed_positions";

  return (
    <>
      <div className="c-tax-harvesting-tabs">
        {RESULT_TABS.map((tab) => (
          <button
            key={tab.code}
            type="button"
            className={classNames(
              "c-tax-harvesting-tabs__tab",
              active === tab.code && "is-active",
            )}
            onClick={() => onChange(tab.code)}
          >
            <span className="c-tax-harvesting-tabs__label">{tab.label}</span>
          </button>
        ))}
      </div>

      {SUBTITLES[active] && (
        <p className="c-tax-harvesting-subtitle">{SUBTITLES[active]}</p>
      )}
      
      {isEstimated && <ColumnLegend />}

    </>
  );
}
